const KEY_ACTIVE = 'agendamentos-app:platform:active'
const LEGACY_KEY = 'agendamentos-app:platform-admin-token'

function clearLegacyToken(): void {
  try {
    localStorage.removeItem(LEGACY_KEY)
  } catch {
    /* ignore */
  }
}

export function markPlatformSessionActive(): void {
  try {
    sessionStorage.setItem(KEY_ACTIVE, '1')
    clearLegacyToken()
  } catch {
    /* ignore */
  }
}

export function getPlatformToken(): string | null {
  return null
}

export function setPlatformToken(_token: string): void {
  markPlatformSessionActive()
  clearLegacyToken()
}

export function clearPlatformToken(): void {
  try {
    sessionStorage.removeItem(KEY_ACTIVE)
    clearLegacyToken()
  } catch {
    /* ignore */
  }
}

export function isPlatformAdmin(): boolean {
  try {
    clearLegacyToken()
    return sessionStorage.getItem(KEY_ACTIVE) === '1'
  } catch {
    return false
  }
}
